import { render, staticRenderFns } from "./LeadForms.vue?vue&type=template&id=e2df4e70"
import script from "./LeadForms.vue?vue&type=script&lang=js"
export * from "./LeadForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports